import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import { ListGroup, Accordion, Card, Image, Badge, useAccordionButton, AccordionContext, Container, Row } from 'react-bootstrap';
import Logo from '../../assets/images/brand/logo/logo-black.png';
import ROUTES from '../../constants/routes';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import { isBooleanFalse } from '../../utils/objectUtils';
import { FaFacebook } from 'react-icons/fa';
import CONSTANTS from '../../constants';

const NavbarVertical = ({ onClick, showMenu, menuOptions = [] }) => {
	//#region useSearchParams

	const [searchParams, setSearchParams] = useSearchParams();

	//#endregion
	//#region useLocation

	const location = useLocation();

	//#endregion

	const isMobile = useMediaQuery({ maxWidth: 767 });

	const CustomToggle = ({ children, eventKey, icon }) => {
		const { activeEventKey } = React.useContext(AccordionContext);

		const decoratedOnClick = useAccordionButton(eventKey, () => {
			// console.log('Event Key : ' + eventKey)
		});

		const isCurrentEventKey = activeEventKey === eventKey;

		return (
			<li className="nav-item">
				<Link
					className="nav-link "
					onClick={decoratedOnClick}
					to="#!"
					data-bs-toggle="collapse"
					data-bs-target="#navDashboard"
					aria-expanded={isCurrentEventKey ? true : false}
					aria-controls="navDashboard"
				>

					{icon ? (typeof icon === 'string' ? (
						<i className={`nav-icon fe fe-${icon} me-2`}></i>
					) : (
						icon
					)) : ''}{' '}
					{children}
				</Link>
			</li>
		);
	};

	const generateLink = (item) => {
		if (item.link) {
			return (
				<Link
					className={`nav-link ${location.pathname === item.link ? 'active' : ''
						}`}
					to={{ pathname: item.link, search: searchParams.toString() }}
					onClick={(e) =>
						isMobile ? onClick(!showMenu) : showMenu
					}
				>
					{item.name}
					{''}
					{item.badge ? (
						<Badge
							className="ms-1"
							bg={item.badgecolor ? item.badgecolor : 'primary'}
						>
							{item.badge}
						</Badge>
					) : (
						''
					)}
				</Link>
			);
		} else if (item.externalLink) {
			return (
				<a
					href={item.externalLink}
					target='_blank'
					className={`nav-link ${location.pathname === item.externalLink ? 'active' : ''
						}`}
				>
					{item.name}
					{''}
					{item.badge ? (
						<Badge
							className="ms-1"
							bg={item.badgecolor ? item.badgecolor : 'primary'}
						>
							{item.badge}
						</Badge>
					) : (
						''
					)}
				</a>
			);
		} else {
			return null;
		}
	};

	return (
		<React.Fragment>
			<SimpleBar style={{ maxHeight: '100vh', width: '100%' }}>
				<div className="nav-scroller">
					<Link className="navbar-brand" to={{ pathname: ROUTES.LANDING, search: searchParams.toString() }}>
						<Image src={Logo} alt="" loading="lazy" />
					</Link>
				</div>
				{/* Dashboard Menu */}
				<div className="d-flex flex-column align-items-start justify-content-between">
				<Accordion
					defaultActiveKey="0"
					as="ul"
					className="navbar-nav flex-column"
				>
					{menuOptions.filter(i => !isBooleanFalse(i.show)).map(function (menu, index) {
						if (menu.grouptitle) {
							return (
								<Card bsPrefix="nav-item" key={index}>
									{/* group title item */}
									<div className="navbar-heading">{menu.title}</div>
									{/* end of group title item */}
								</Card>
							);
						} else {
							if (menu.children) {
								return (
									<React.Fragment key={index}>
										{/* main menu / menu level 1 / root items */}
										<CustomToggle eventKey={menu.id} icon={menu.icon}>
											{menu.title}
											{menu.badge ? (
												<Badge
													className="ms-1"
													bg={menu.badgecolor ? menu.badgecolor : 'primary'}
												>
													{menu.badge}
												</Badge>
											) : (
												''
											)}
										</CustomToggle>
										<Accordion.Collapse
											eventKey={menu.id}
											as="li"
											bsPrefix="nav-item"
										>
											<Accordion className="navbar-nav flex-column" as="ul">
												<ListGroup
													as="ul"
													bsPrefix=""
													className="nav flex-column"
												>
													{menu.children.filter(i => !isBooleanFalse(i.show)).map(function (
														menuItem,
														menuItemIndex
													) {
														if (menuItem.children) {
															return (
																<React.Fragment key={menuItemIndex}>
																	{/* second level with children */}
																	<CustomToggle eventKey={menuItem.id}>
																		{menuItem.title}
																		{menuItem.badge ? (
																			<Badge
																				className="ms-1"
																				bg={
																					menuItem.badgecolor
																						? menuItem.badgecolor
																						: 'primary'
																				}
																			>
																				{menuItem.badge}
																			</Badge>
																		) : (
																			''
																		)}
																	</CustomToggle>
																	<Accordion.Collapse
																		eventKey={menuItem.id}
																		bsPrefix="nav-item"
																		as="li"
																	>
																		<Accordion
																			className="navbar-nav flex-column"
																			as="ul"
																		>
																			<ListGroup
																				as="ul"
																				bsPrefix=""
																				className="nav flex-column"
																			>
																				{/* third level menu started  */}
																				{menuItem.children.filter(i => !isBooleanFalse(i.show)).map(function (
																					subMenuItem,
																					subMenuItemIndex
																				) {
																					return subMenuItem.children ? (
																						<React.Fragment key={subMenuItemIndex}>
																							<CustomToggle
																								eventKey={subMenuItem.id}
																							>
																								{subMenuItem.title}
																								{subMenuItem.badge ? (
																									<Badge
																										className="ms-1"
																										bg={
																											subMenuItem.badgecolor
																												? subMenuItem.badgecolor
																												: 'primary'
																										}
																									>
																										{subMenuItem.badge}
																									</Badge>
																								) : (
																									''
																								)}
																							</CustomToggle>
																							<Accordion.Collapse
																								eventKey={subMenuItem.id}
																								bsPrefix="nav-item"
																								as="li"
																							>
																								<ListGroup
																									as="ul"
																									bsPrefix=""
																									className="nav flex-column"
																								>
																									{subMenuItem.children.filter(i => !isBooleanFalse(i.show)).map(
																										function (
																											thirdLevelItem,
																											thirdLevelItemIndex
																										) {
																											return (
																												<ListGroup.Item
																													key={
																														thirdLevelItemIndex
																													}
																													as="li"
																													bsPrefix="nav-item"
																												>
																													{/* third level with children */}
																													{generateLink(
																														thirdLevelItem
																													)}
																												</ListGroup.Item>
																											);
																										}
																									)}
																								</ListGroup>
																							</Accordion.Collapse>
																						</React.Fragment>
																					) : (
																						<ListGroup.Item
																							key={subMenuItemIndex}
																							as="li"
																							bsPrefix="nav-item"
																						>
																							{/* third level without children */}
																							{generateLink(subMenuItem)}
																						</ListGroup.Item>
																					);
																				})}
																				{/* end of third level menu  */}
																			</ListGroup>
																		</Accordion>
																	</Accordion.Collapse>
																	{/* end of second level with children */}
																</React.Fragment>
															);
														} else {
															return (
																<ListGroup.Item
																	as="li"
																	bsPrefix="nav-item"
																	key={menuItemIndex}
																>
																	{/* second level without children */}
																	{generateLink(menuItem)}
																	{/* end of second level without children  */}
																</ListGroup.Item>
															);
														}
													})}
												</ListGroup>
											</Accordion>
										</Accordion.Collapse>
										{/* end of main menu / menu level 1 / root items */}
									</React.Fragment>
								);
							} else {
								return (
									<Card bsPrefix="nav-item" key={index}>
										{/* menu item without any childern items like Help Center, Documentation and Changelog items*/}
										{menu.link && (
											<Link
												to={{ pathname: menu.link, search: searchParams.toString() }}
												onClick={(e) =>
													isMobile ? onClick(!showMenu) : showMenu
												}
												className={`nav-link ${location.pathname === menu.link ? 'active' : ''
													}`}
											>
												{typeof menu.icon === 'string' ? (
													<i className={`nav-icon fe fe-${menu.icon} me-2`}></i>
												) : (
													menu.icon
												)}
												{menu.title}
												{menu.badge ? (
													<Badge
														className="ms-1"
														bg={menu.badgecolor ? menu.badgecolor : 'primary'}
													>
														{menu.badge}
													</Badge>
												) : (
													''
												)}
											</Link>
										)}
										{menu.externalLink && (
											<a
												href={menu.externalLink}
												target='_blank'
												className={`nav-link ${location.pathname === menu.link ? 'active' : ''
													}`}
											>
												{typeof menu.icon === 'string' ? (
													<i className={`nav-icon fe fe-${menu.icon} me-2`}></i>
												) : (
													menu.icon
												)}
												{menu.title}
												{menu.badge ? (
													<Badge
														className="ms-1"
														bg={menu.badgecolor ? menu.badgecolor : 'primary'}
													>
														{menu.badge}
													</Badge>
												) : (
													''
												)}
											</a>
										)}
										{/* end of menu item without any childern items */}
									</Card>
								);
							}
						}
					})}
				</Accordion>
				{/* end of Dashboard Menu */}
				<footer className="footer text-gray-800">
					<Container>

						<Row className="align-items-start g-0 border-top py-2 mt-1">
							{/* Desc  */}
							<div className="text-start">
								<span className="text-start">{`Copyright © ${new Date().getFullYear()} ${CONSTANTS.COMPANY_NAME}. All rights reserved.`}</span>
								<div>Version {process.env.REACT_APP_VERSION}</div>
							</div>
						</Row>
					</Container>
				</footer>
				</div>
			</SimpleBar>
		</React.Fragment>
	);
};

export default NavbarVertical;